<template>
  <div class="blackList-box">
    <!--操作栏-->

    <div class="action-bar">
      <el-input
        v-model.number="params.uid"
        placeholder="请输入用户ID"
        size="small"
        clearable
        class="param-input"
      ></el-input>
      <el-input
        v-model.trim="params.content"
        placeholder="请输入关键字"
        size="small"
        clearable
        class="param-input"
      ></el-input>
      <el-select
        placeholder="请选择反馈类型"
        v-model="params.fType"
        clearable
        filterable
        size="small"
      >
        <el-option
          v-for="item in types"
          :key="item.id"
          :value="item.fType"
          :label="item.fType"
        ></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="search('status')"
        >搜索</el-button
      >
      <el-button
        type="primary"
        size="small"
        @click="batchDelete('delete')"
        :disabled="isDisabled"
        >批量删除</el-button
      >
    </div>

    <!--表格数据-->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      ref="multipleTable"
      height="650"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        v-if="isBatchDelete"
        width="55"
        fixed="left"
        align="center"
      ></el-table-column>
      <el-table-column prop="id" label="ID" align="center" min-width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.id || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.uid || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="fType"
        label="反馈类型"
        align="center"
        min-width="140"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.fType || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="content"
        label="关键字"
        align="center"
        min-width="140"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.content || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="replay"
        label="快捷回复"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.replay || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="version"
        label="版本号"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.version || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="devType"
        label="设备型号"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.devType || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="devType"
        label="设备信息"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.device || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="carrier"
        label="运营商"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.carrier || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="location"
        label="所在地"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.location || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="contact"
        label="联系方式"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.contact || "未知" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="seriesCover"
        label="图集预览"
        align="center"
        min-width="190"
      >
        <template slot-scope="scope">
          <span v-if="!scope.row.img || !scope.row.img.length">未知</span>
          <div
            v-else
            class="picturePreview"
          >
           
           
            <gallery :list="scope.row.img" ></gallery>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="更新时间"
        align="center"
        min-width="160"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        fixed="right"
        min-width="200"
      >
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="action(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="remove(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--分页组件-->
    <div class="bottom">
      <div class="btn" v-if="isBatchDelete">
        <el-button type="info" size="mini" @click="giveUp">放弃操作</el-button>
        <el-button type="primary" size="mini" @click="subSection"
          >确认删除</el-button
        >
      </div>
    <el-pagination
      :page-sizes="[10, 15, 20, 30]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 1"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
    <!--编辑反馈信息弹窗-->
    <edit-feedback
      ref="editFeedback"
      @handlerAddblack="getFeedbackList"
    ></edit-feedback>
    <!-- 图集预览窗口 -->
    <preview-picture ref="previewPicture"></preview-picture>
  </div>
</template>
<script>
import { paramsFilter } from "@/utils/global";
import baseConfig from "@/utils/serverUrlConfig";
import EditFeedback from "./components/editFeedback";
import PreviewPicture from "./components/previewPicture";
import API from "@/api";
export default {
  data() {
    return {
      imgUrl: baseConfig.imgUrl,
      newImgUrl: baseConfig.newImgUrl,
      // 表格数据加载动画
      loading: false,
      tableData: [],
      time: "",
      total: 0,
      // 反馈信息类型
      blackType: [
        {
          label: "IP",
          value: "IP",
        },
      ],
      // 用户管理列表请求参数
      params: {
        type: "",
        content: "",
        fType: "",
        pageNumber: 1,
        pageSize: 10,
      },
      types: [],
      isBatchDelete: false,
      deleteArr: [],
      isDisabled: false,
    };
  },
  components: {
    EditFeedback,
    PreviewPicture,
  },
  created() {
    this.getFeedbackType();
    this.getFeedbackList();
  },
  methods: {
    // 批量删除
    async batchDelete() {
      this.isBatchDelete = true;
      this.isDisabled = true;
    },
    // 处理勾选时的数据
    handleSelectionChange(objArr) {
      this.deleteArr = objArr.map((item) => {
        return item.id;
      });
    },
    giveUp() {
      this.isDisabled = false;
      this.isBatchDelete = false;
      this.deleteArr = [];
      this.$refs.multipleTable.clearSelection();
    },
    subSection() {
      if (this.deleteArr.length <= 0) {
        this.$message.error("请选择需要删除的");
        return;
      }
      this.$confirm("确定批量删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          ids: this.deleteArr,
        };
        API.delFeedbackAll(params).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "批量删除成功",
              type: "success",
            });
            this.giveUp();
            this.getFeedbackList();
          } else {
            this.$message.error("批量删除失败");
          }
        });
      });
    },
    checkUrl(domain) {
      if (!domain) {
        return "";
      }
      var patt = /^http(s)?:\/\/.+/;
      if (!patt.test(domain)) {
        if (domain[0] == "/") {
          return this.newImgUrl + domain;
        } else {
          return this.imgUrl + domain;
        }
      } else {
        return domain;
      }
    },
    // 图集预览
    previewPicture(pictureArr, id) {
      let Arr = JSON.parse(JSON.stringify(pictureArr));
      this.$refs.previewPicture.open(Arr, id);
    },
    getFeedbackType() {
      this.loading = true;
      API.getFeedbackTypes()
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.types = res.data.list;
            console.log(this.types)
          } else {
            this.types = [];
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 请求反馈信息列表
    getFeedbackList(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      let params = paramsFilter(this.params);
      API.getFeedbackList(params)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    // 新增、修改tags
    action(type) {
      this.$refs.editFeedback.open(type);
    },
    // 删除
    remove(row) {
      this.$confirm("您确定要删除当前反馈信息吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.delFeedback({ ids: [row.id] }).then((res) => {
            if (res.code === 200) {
              this.$message({
                message: "删除反馈信息成功",
                type: "success",
              });
              this.getFeedbackList();
            } else {
              this.$message.error("删除失败");
            }
          });
        })
        .catch(() => {});
    },

    // 搜索对应列表
    search(type) {
      this.params.pageNumber = 1;
      this.getFeedbackList(type);
    },
    // 监听新增成功回掉
    getAddblack() {
      this.getFeedbackList();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.params.pageNumber = 1;
      this.getFeedbackList();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getFeedbackList();
    },
  },
};
</script>
<style lang="scss">
.picturePreview {
  max-width: 500px;
  display: flex;
  flex-wrap: wrap;
}
</style>
